<template>
  <b-container fluid>
    <b-row>
      <b-col lg="6" offset-lg="3">
        <iq-card>
          <template v-slot:body>
            <h1 class="card-title text-center">Loading contacts</h1>
            <h3 class="text-center" v-if="!error">
              <i class="fas fa-spinner fa-spin ml-2"></i>
            </h3>
            <b-alert :show="true" variant="danger" v-if="error">
              <div class="iq-alert-text">Failed to load contacts.</div>
            </b-alert>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { core } from "../../config/pluginInit";
import gql from "graphql-tag";
const CREATE_LIST = gql`
  mutation createList($name: String!) {
    insert_lists_one(object: { name: $name }) {
      id
      name
    }
  }
`;

export default {
  name: "ListsCreateAndEdit",
  data() {
    return {
      error: null
    };
  },
  mounted() {
    core.index();
    this.createAndRedirectToList();
  },
  methods: {
    async createAndRedirectToList() {
      const listName = "untitled list";
      try {
        const saveResponse = await this.$apollo.mutate({
          mutation: CREATE_LIST,
          variables: {
            name: listName
          }
        });
        // this.$toast.success(`List created`);
        this.$router.replace(
          `/lists/${saveResponse.data.insert_lists_one.id}/edit`
        );
      } catch (error) {
        this.error = error;
      }
    }
  }
};
</script>
